export const navigationItems = [
  { title: "Головна", type: "route", link: "/" },
  { title: "Приклади", type: "scroll", link: "examples" },
  { title: "Пакети", type: "scroll", link: "packages" },
  { title: "Відгуки", type: "scroll", link: "comments" },
  { title: "Часті запитання", type: "scroll", link: "questions" },
];
